module.exports = "/assets/a3c745e25ce2f5bf66b738c2e31e8da3.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/BY.png
// module id = 2376
// module chunks = 0